export enum ESex {
    Male = 'M',
    Female = 'F'
}

export enum ERegistrationType {
  Contact = 0,
  Customer = 1,
  Helpdesk = 2,
  Supplier = 3,
  User = 4,
  Visitor = 5,
}
export enum EGenderType {
  Others = 0,
  Male = 1,
  Female = 2,
}

export const GenderTypeMap = {
  [EGenderType.Others]: '',
  [EGenderType.Male]: ESex.Male,
  [EGenderType.Female]: ESex.Female,
};

export const RegistrationTypeMap: Partial<Record<ERegistrationType, string>> = {
  [ERegistrationType.Customer]: 'C',
  [ERegistrationType.User]: 'U',
  [ERegistrationType.Visitor]: 'V',
};